import { createFileRoute } from "@tanstack/react-router";
import { Loader } from "@/shared/coralreef";

export const Route = createFileRoute("/boot")({
  component: BootPage,
});

function BootPage() {
  return (
    <div
      data-testid="boot-loading"
      style={{
        display: "flex",
        flex: 1,
        height: "100%",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Loader />
    </div>
  );
}
